import type * as Types from '../../graphql/types.d'

import type { PinnedRouteSelectionFragment } from '../fragments/generated/PinnedRoute'
import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type PinnedRoutesQueryVariables = Types.Exact<{
  filter?: Types.Maybe<Types.TravelPinnedSegmentConnectionFilterInput>
}>

export type PinnedRoutesQuery = { __typename?: 'Query' } & {
  pinnedRoutesConnection: { __typename?: 'PinnedRouteConnection' } & Pick<
    Types.PinnedRouteConnection,
    'totalCount'
  > & {
      pageInfo: { __typename?: 'PageInfo' } & Pick<Types.PageInfo, 'endCursor' | 'hasNextPage'>
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'PinnedRouteEdge' } & Pick<Types.PinnedRouteEdge, 'cursor'> & {
                node?: Types.Maybe<{ __typename?: 'PinnedRoute' } & PinnedRouteSelectionFragment>
              }
          >
        >
      >
    }
}

export const PinnedRoutesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PinnedRoutes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TravelPinnedSegmentConnectionFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pinnedRoutesConnection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'PinnedRouteSelection' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PinnedRouteSelection' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PinnedRoute' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationFrequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationChannel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode
